//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectObject.js";
let d=[[[0,"FlipEnum",1,0],[0,"MountEnum",1,0],[1,"SelectSource",0,"SelectDisplayableObject",0],[1,"SelectTarget",0,"SelectDisplayableObject",0]],[[[],"FlipButton",{},0,0]],[]];
SPLM.LineDesigner.MountBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.MountBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.MountBuilder.MountType = Object.freeze({
    "MoveandMount" : "MoveandMount", "MountOnly" : "MountOnly"});

SPLM.LineDesigner.MountBuilder.FlipType = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z"});

export default SPLM;